import { COLOR_KEYS, ICON_NAMES } from '../../../constants';
import { FeaturesSectionProps } from './FeaturesSection';

export const defaultValues: FeaturesSectionProps = {
  backgroundColor: COLOR_KEYS.neutral100,
  heading: 'Automation you can trust',
  description:
    '<p>Because what good is automation unless it’s secure and reliable?</p>',
  features: [
    {
      iconName: ICON_NAMES.miscSecurity,
      heading: 'Security features',
      description:
        '<p>At Zapier, we take security and privacy seriously. Learn more about our security practices.</p>',
    },
    {
      iconName: ICON_NAMES.ratingThumbsUp,
      heading: 'SOC  II compliant',
      description:
        '<p>Zapier meets all SOC 2 Type II requirements, so you can automate with confidence.</p>',
    },
    {
      iconName: ICON_NAMES.actionAutoRenew,
      heading: 'Auto-replay',
      description:
        '<p>If a Zap fails or encounters an error, we’ll re-run it automatically so your work keeps happening.</p>',
    },
    {
      iconName: ICON_NAMES.navCog,
      heading: 'Advanced controls',
      description:
        '<p>Need advanced administrative or security features? Check out Zapier for Companies.</p>',
    },
  ],
};
